import { useEffect, useState } from "react";
import { useConvexAuth, useQuery } from "convex/react";
import { api } from "../../../convex/_generated/api";
import { AuthScreen } from "./auth/AuthScreen";
import { Onboarding } from "./auth/Onboarding";
import { PasskeyEnrollment } from "./auth/PasskeyEnrollment";
import { PasskeyVerification } from "./auth/PasskeyVerification";
import { SubscriptionLocked } from "./auth/SubscriptionLocked";
import { useTheme } from "./theme";
import { ComposerDraftProvider } from "./workspace/ComposerDrafts";
import { Workspace } from "./workspace/Workspace";

function BootScreen() {
  const [slow, setSlow] = useState(false);
  useEffect(() => {
    const timeout = window.setTimeout(() => { setSlow(true); }, 8_000);
    return () => { window.clearTimeout(timeout); };
  }, []);

  return (
    <main className="boot-screen" id="main-content" aria-busy={!slow}>
      <div className="brand-mark" aria-label="Yodl"><span>Y</span></div>
      <div className="boot-status" role="status">
        <strong>{slow ? "Yodl is taking longer than expected" : "Opening Yodl…"}</strong>
        <span>{slow ? "Your account is safe. Reload to fetch the latest secure version." : "Checking your secure session."}</span>
      </div>
      {slow ? <button className="button button--primary" type="button" onClick={() => { window.location.reload(); }}>Reload Yodl</button> : null}
    </main>
  );
}

export function App() {
  const { isLoading, isAuthenticated } = useConvexAuth();
  const me = useQuery(api.workspace.me, isAuthenticated ? {} : "skip");
  useTheme();

  if (isLoading) return <BootScreen />;
  if (!isAuthenticated) return <AuthScreen />;
  if (me === undefined) return <BootScreen />;
  if (me.status === "signed-out") return <AuthScreen />;
  if (me.user.passkeyEnrollmentRequired) return <PasskeyEnrollment />;
  if (me.status === "passkey-required") return <PasskeyVerification />;
  if (me.status === "ready" && me.billing?.locked === true) return <SubscriptionLocked me={me} />;
  if (me.status === "ready") return <ComposerDraftProvider key={`${me.workspace.id}:${me.principalId}`}><Workspace me={me} /></ComposerDraftProvider>;
  return <Onboarding me={me} />;
}
